var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          !_vm.events
            ? _c("v-skeleton-loader", {
                staticClass: "mx-auto",
                attrs: { type: "list-item-avatar-three-line" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.events, function (feedback) {
        return _c(
          "v-list-item",
          { key: feedback.id },
          [
            _c(
              "v-list-item-avatar",
              { staticClass: "align-self-start mt-3", attrs: { size: "64" } },
              [
                _c("v-img", {
                  attrs: { src: feedback.user.profile_photo_url, size: "64" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-list-item-content",
              [
                _c("v-list-item-title", { staticClass: "soli-grey" }, [
                  _vm._v(
                    _vm._s(`${feedback.user.name}${_vm.relation(feedback)}`)
                  ),
                ]),
                _vm._v(" "),
                _c("v-list-item-subtitle", [
                  _vm._v(
                    _vm._s(
                      `${_vm.globalMomentFullDateAtTimeShort(
                        feedback.starts_at
                      )} with ${feedback.teacher.name}`
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "v-list-item-subtitle",
                  _vm._l([1, 2, 3, 4, 5], function (i) {
                    return _c(
                      "v-icon",
                      { key: i, staticClass: "soli-grey soli-blue-text" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              feedback.rating >= i ? "star" : "star_outline"
                            ) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-item-subtitle",
                  {
                    staticClass: "soli-grey",
                    staticStyle: { "white-space": "normal" },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(feedback.comment) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }